<template>
  <div class="card mb-3">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div>
        <i class="fa fa-layer-group text-cr-red-black mr-2"></i>
        <router-link
          v-if="isClickable"
          :to="{name: 'research-set', params: {uuid: researchSet.uuid}}"
        >
          {{ researchSet.name }}
        </router-link>
        <span v-else>
          {{ researchSet.name }}
        </span>
      </div>
      <div>
        <v-button
          icon="random"
          styleType="link"
          size="sm"
          v-title="$t('phrase.load_other_commercials')"
          @click="shuffleResearches()"
        />
      </div>
    </div>
    <div class="card-body pb-2">
      <div v-if="researchSet.description">
        <div v-html="researchSet.description"></div>
        <hr/>
      </div>

      <transition name="fade">
        <div class="row" v-if="researches.length > 0">
          <div
            v-for="research in researches"
            :key="research.uuid"
            class="col-md-6 mb-3"
          >
            <v-reviewer-research-card
              :research="research"
            />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import ReviewerResearchCard from '@/reviewer/components/ReviewerResearchCard.vue';
import { fetchResearchSetResearches } from '@/reviewer/api';

export default {
  name: 'ResearchSet',
  components: {
    'v-reviewer-research-card': ReviewerResearchCard,
    'v-button': Button,
  },
  props: {
    isClickable: {
      type: Boolean,
      default: true,
    },
    researchSet: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async shuffleResearches() {
      this.researches = [];
      const response = await fetchResearchSetResearches(this.researchSet.uuid);
      this.researches = response.data;
    },
  },
  data() {
    return {
      researches: [],
    };
  },
  created() {
    this.researches = this.researchSet.researches;
  },
};
</script>
